/**
 * 数据导出API
 */
import { apiClient } from './client';

export interface ExportRequest {
  data_type: 'price' | 'storage' | 'production' | 'trade';
  format: 'csv' | 'excel';
  fields?: string[];
  filters?: Record<string, any>;
  email?: string;
}

export interface ExportResponse {
  download_url?: string;
  message?: string;
  record_count: number;
  file_size?: number;
}

/**
 * 导出CSV数据
 */
export const exportCSV = async (request: ExportRequest): Promise<Blob> => {
  const response = await apiClient.post('/export/csv', request, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * 导出Excel数据
 */
export const exportExcel = async (request: ExportRequest): Promise<Blob> => {
  const response = await apiClient.post('/export/excel', request, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * 触发文件下载
 */
export const downloadFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
